import React from "react";

import Button from "../../button/Button";
import { useUser } from "../../../context/UserContext";
import AccountSubHeader from "../accountSubHeader/accountSubheader";

import { PersonalDetailsProps } from "../types";
import styles from "./personalDetails.module.css";

const PersonalDetails = ({
  userProfile,
  handleEditClick,
  manageSubscriptionLink,
}: PersonalDetailsProps): JSX.Element => {
  if (userProfile) {
    return (
      <div>
        <AccountSubHeader title="Personal details">
          <Button onClick={handleEditClick} text="Edit" />
          {manageSubscriptionLink && (
            <Button
              extraButtonProps={{ target: "_blank" }}
              href={manageSubscriptionLink}
              className={styles.button}
              // onClick={handleEditClick}
              text="Change payment details"
            />
          )}
        </AccountSubHeader>
        <div className={styles.container}>
          <div className={styles.details}>
            {!userProfile.firstName && (
              <div className={styles.initialMessage}>
                Click edit to get started
              </div>
            )}
            <div>
              {userProfile.firstName ? userProfile.firstName : ""}{" "}
              {userProfile.lastName ? userProfile.lastName : ""}
            </div>
            <div>{userProfile.babyName}</div>
            <div>{userProfile.email}</div>
            <div>{userProfile.contactNumber}</div>
            <div className={styles.space}></div>
            <div>
              {userProfile.firstName} {userProfile?.lastName}
            </div>
            {userProfile.address1 && (
              <>
                <div>{userProfile.address1}</div>
                <div>{userProfile.address2}</div>
                <div>
                  {userProfile.city}, {userProfile.postcode}
                </div>
                <div>{userProfile.country}</div>
              </>
            )}
          </div>
        </div>
      </div>
    );
  } else {
    return <></>;
  }
};

export default PersonalDetails;
